import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface BillingTimerState {
  isActive: boolean;
  elapsedTime: number; // in seconds
  isPaused: boolean;
  participantId: string | null;
}

const initialState: BillingTimerState = {
  isActive: false,
  elapsedTime: 0,
  isPaused: false,
  participantId: null,
};

export const billingTimerSlice = createSlice({
  name: "billingTimer",
  initialState,
  reducers: {
    startTimer: (
      state,
      action: PayloadAction<{ participantId: string; initialTime: number }>
    ) => {
      state.isActive = true;
      state.isPaused = false;
      state.elapsedTime = action.payload.initialTime;
      state.participantId = action.payload.participantId;
    },
    pauseTimer: (state) => {
      state.isPaused = true;
    },
    resumeTimer: (state, action: PayloadAction<number>) => {
      state.isPaused = false;
      state.elapsedTime = action.payload;
    },
    updateElapsedTime: (state, action: PayloadAction<number>) => {
      if (state.isActive && !state.isPaused) {
        state.elapsedTime = action.payload;
      }
    },
    resetTimer: () => initialState,
  },
});

export const {
  startTimer,
  pauseTimer,
  resumeTimer,
  updateElapsedTime,
  resetTimer,
} = billingTimerSlice.actions;

export default billingTimerSlice.reducer;
